import { render, staticRenderFns } from "./join-detail.vue?vue&type=template&id=92ac223a&scoped=true"
import script from "./join-detail.vue?vue&type=script&lang=js"
export * from "./join-detail.vue?vue&type=script&lang=js"
import style0 from "./join-detail.vue?vue&type=style&index=0&id=92ac223a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ac223a",
  null
  
)

export default component.exports